// 应用初始状态
export default {
  sideMenuShow: true, // 侧边栏导航展示状态
  collapse: false, // 侧边导航是否折叠展示
  modulesMenuShow: false, // 汉堡导航展示状态
  auth: [], // 用户完整路由权限
  authHad: false, // 是否获取过路由权限
  router: [], // 当前侧边导航显示内容
  sysList: [], // 用户完整的系统树形结构
  userInfo: {}, // 用户信息
  tableQuery: {}, // TableSearch 与 TableTable之前的通信请求参数
  headerShow: true,//头部显示状态
  keepAliveRoutes: [], // 需要缓存的页面组件
}


// WEBPACK FOOTER //
// ./src/vuex/state.js